import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { CountdownTimer } from './CountdownTimer';
export function PricingSection() {
  const href = 'https://rescate-intestinal.impultienda.ar/checkout';
  return <section id="pricing" className="bg-brand-dark relative" data-id="element-171" data-mp="1egnv472rsezx">
      {/* Urgency countdown with dark red background - full width */}
      <div className="bg-[#1a0808] py-24" data-id="element-172" data-mp="1nakcz9owj59j">
        <div className="container mx-auto px-4" data-id="element-173" data-mp="1n9iqm92fqwci">
          <div className="max-w-5xl mx-auto text-center" data-id="element-174" data-mp="1ncwp367zaleo">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} data-id="element-175" data-mp="1s8c1dtqc898z">
              <h2 className="text-2xl font-bold mb-6 flex items-center justify-center gap-2 text-[#FFFFFF]" data-id="element-176" data-mp="2w0gaw9eae0o">
                ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
              </h2>
              <CountdownTimer data-id="element-177" data-mp="1mgy99btrc4wd" />
              <p className="text-gray-400 mt-6 mb-4 flex items-center justify-center gap-2" data-id="element-178" data-mp="1mhzgt6bke99c">
                <span className="text-yellow-500" data-id="element-179" data-mp="1hodhefuew1vh">⚠️</span> Después sube.{' '}
                <span className="text-white font-bold" data-id="element-180" data-mp="1crwqjdvtv9ep">No vuelve.</span>
              </p>

              <div className="max-w-md mx-auto bg-brand-black p-4 rounded-xl border border-red-500/20" data-id="element-181" data-mp="17sjv44qw4u0i">
                <div className="flex justify-between text-sm mb-2 text-red-400 font-medium" data-id="element-182" data-mp="25ehgqb0khfgo">
                  <span data-id="element-183" data-mp="20g64xuqpouvt">🔴 Cupos al precio de lanzamiento</span>
                  <span data-id="element-184" data-mp="1vhcte7uzjdya">Quedan pocos</span>
                </div>
                <div className="w-full bg-gray-800 rounded-full h-2.5" data-id="element-185" data-mp="1vfs16ow5873l">
                  <div className="bg-red-500 h-2.5 rounded-full" style={{
                  width: '68%'
                }} data-id="element-186" data-mp="1repx9ura76va"></div>
                </div>
                <p className="text-xs text-gray-500 mt-2 text-right" data-id="element-187" data-mp="fz19x2a485ty">
                  68% de los cupos ya tomados
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Pricing card */}
      <div className="container mx-auto px-4 py-16 md:py-24" data-id="element-188" data-mp="7jlqkescvphr">
        <div className="max-w-2xl mx-auto" data-id="element-189" data-mp="7jc24vmylqe6">
          <div className="text-center mb-8 md:mb-12" data-id="element-190" data-mp="ciezdtwp6sbl">
            <h2 className="text-3xl md:text-4xl font-bold font-[Poppins,_sans-serif]" data-id="element-191" data-mp="cgu2vyqtozb3">
              TU SISTEMA COMPLETO
            </h2>
          </div>

          {/* Single Offer */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-black rounded-2xl md:rounded-3xl p-6 md:p-10 border-2 border-brand-green shadow-[0_0_20px_rgba(34,197,94,0.15)] flex flex-col" data-id="element-192" data-mp="3jjpa6qj8y30">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4" data-id="element-193" data-mp="3g184rjfboauo">
              <div className="min-w-0" data-id="element-194" data-mp="2xcxzshav8lo4">
                <div className="text-base md:text-lg font-bold text-brand-light mb-1" data-id="element-195" data-mp="2scs5suh4in2v">
                  🌿 SISTEMA RESCATE INTESTINAL +55™
                </div>
                <p className="text-sm text-gray-400 mb-2" data-id="element-196" data-mp="369f3x0ktbjad">
                  6 Volúmenes + 5 Bonos
                </p>
                <p className="text-sm text-brand-green font-medium" data-id="element-197" data-mp="3g9ph4l6ukqpj">
                  6 guías completas en PDF + 5 bonos estratégicos de regalo.
                  Acceso inmediato.
                </p>
              </div>
              <div className="text-left md:text-right shrink-0" data-id="element-198" data-mp="3p2j1gx15iga9">
                <div className="text-gray-500 line-through text-base" data-id="element-199" data-mp="3l0nvvgc6tgqo">
                  $65.000
                </div>
                <div className="text-4xl md:text-5xl font-bold text-brand-green leading-tight" data-id="element-200" data-mp="2uje5mpk4a6f">
                  $19.990
                </div>
                <div className="text-xs text-gray-400" data-id="element-201" data-mp="3u36z41jvxvdg">ARS</div>
              </div>
            </div>
          </motion.div>

          {/* CTA Button */}
          <div className="max-w-lg md:max-w-2xl mx-auto mt-6 md:mt-10" data-id="element-202" data-mp="lz603gwenozd">
            <Button href={href} showBadges className="w-full py-4 text-base md:text-lg bg-brand-green hover:bg-brand-light" data-id="element-203" data-mp="lxbiabgfkczi">
              🌿 QUIERO MI SISTEMA AHORA
            </Button>
          </div>
        </div>
      </div>
    </section>;
}